import { create } from '@storybook/theming';

export default create({
  base: 'light',
  textColor: '#222',
  brandTitle: 'PHZH Website',
  brandUrl: 'https://phzh.ch',
  brandImage: 'assets/logos/logo-phzh.svg',
  brandTarget: '_blank',
});
